<template>

    <el-dialog :visible.sync="dialogVisible" width="1100px" :close-on-click-modal="false" :title="dialogTitle">
      <div v-loading="uploadLoading">
        <el-tabs v-model="activeName" for-test="activeName">
          <el-tab-pane v-for="item in tabs" :key="item.name" :label="item.label" :name="item.name">
            <el-container>
              <el-aside :width="imgData[item.name].length > 0 ? '340px' : '100%'">
                <el-card>
                  <t-card-header title="相关文件" slot="header">
                    <el-button size="mini" type="primary" @click="handleClickUpload(item.name)">上传</el-button>
                    <el-button size="mini" type="primary" @click="handleClickDownLoad(item.name)"  v-if="caseId">下载</el-button>
                    <el-button size="mini" type="primary" @click="handleClickDelete(item.name)">删除</el-button>
                  </t-card-header>
                  <el-table
                    :highlightCurrentRow = false
                    :data="data[item.name]"
                    :tableProp="[
                    {prop: 'fileName', label:'名称'},
                    {prop: 'uploadTime', label: '上传时间'}]"
                    @select="handleSelect"
                    @select-all="handleSelect"
                  >
                    <el-table-column type="selection"></el-table-column>
                    <el-table-column prop="fileName" label="名称"></el-table-column>
                    <el-table-column prop="uploadTime" label="上传时间"></el-table-column>
                    <t-empty slot="empty"></t-empty>
                  </el-table>
                </el-card>
              </el-aside>
              <el-main style="margin-left:0" v-if="imgData[item.name].length > 0 ">
                <el-card>
                  <t-card-header slot="header" title="图片浏览"></t-card-header>
                  <div class="img-list">
                    <t-img-viewer>
                      <div class="img-item fl" v-for="imgItem in imgData[item.name]">
                        <p>{{imgItem.fileName}}</p>
                        <t-img-base host="" :src=" '../../../' + imgItem.fileUrl" width="330px" height="200px"></t-img-base>
                        <!-imgs-img :src="imgItem.fileUrl" width="330px" height="200px">imgs-img>-->
                      </div>
                    </t-img-viewer>
                  </div>
                </el-card>
              </el-main>
            </el-container>
          </el-tab-pane>
        </el-tabs>
        <input v-show="false" ref="fileInput" type="file" multiple @change="fileChange($event)">
        <el-footer v-if="!caseId">
          <el-card>
            <div class="tr">
              <el-button type="primary" @click="handleClickDeal">确定处理</el-button>
              <el-button type="primary" plain @click="dialogVisible = false">取消</el-button>
            </div>
          </el-card>
        </el-footer>
      </div>
      <el-dialog v-if="rename.visible" :visible.sync="rename.visible" :append-to-body="true" title="文件重命名">
        <el-form :label-position="labelPosition" :model="rename.newFileName">
          <el-form-item v-for="(file, index) in files" :label="file.name">
            <el-input clearable v-model="rename.newFileName[index]" for-test="rename.newFileName[index]"></el-input>
          </el-form-item>
        </el-form>
        <el-button slot="footer" type="primary" @click="uploadStart">确认上传</el-button>
      </el-dialog>
    </el-dialog>

</template>
<style lang="scss" scoped>
  .img-list{
    overflow: hidden;
    .img-item{
      margin:0 7px 5px;
    }
  }
</style>

<!--☯js-->
<script>
  import * as eventJs from '../../../../../../src/base-components/blackHandle/event.js'
  const {event, life, watch} = eventJs.default ? eventJs.default : eventJs
  import * as modelJS from '../../../../../../src/base-components/blackHandle/model.js'
  const model = modelJS.default ? modelJS.default : modelJS
  import * as methodsJs from '../../../../../../src/base-components/blackHandle/methods.js'
  const methodsSource = methodsJs.default ? methodsJs.default : methodsJs
  import vmConfig from '../../../../core/vmConfigHandler.js'
  // 异步加载某些情况下会出问题，原因未知，所以暂时不采用异步加载
  // r => require.ensure([], () => r(require('%path')), 'c-base-blackHandle')
  export default {
    name: 'base-blackHandle', // o not use built-in or reserved HTML elements as component id:img, 意思是不能和html标签同名，那么加个下划线好了
    components: {
      /*import components file template:'base-blackHandle': require('%path').default,
       */
      /*start:import components file*/
/*end:import components file*/
    },
    ...vmConfig(model, life, event, watch, methodsSource)
  }
</script>